/**
 * Ποια διάλεκτο μιλάμε — ΓΛΩΣΣΑ ή Ψευδογλώσσα. Ρητή παράμετρος σε όλο το
 * pipeline (Lexer, Parser): ο Lexer παράγει έναν κοινό κορμό tokens και για
 * τις δύο, αλλά ΟΡΙΣΜΕΝΕΣ δεσμευμένες λέξεις υπάρχουν μόνο στη μία
 * διάλεκτο (π.χ. "Δεδομένα"/"Αποτελέσματα"/"Εμφάνισε" μόνο Ψευδογλώσσα,
 * "ΠΡΟΓΡΑΜΜΑ"/"ΜΕΤΑΒΛΗΤΕΣ" μόνο ΓΛΩΣΣΑ) — χωρίς τη διάλεκτο ο Lexer θα τις
 * δέσμευε και στις δύο, εμποδίζοντας π.χ. μεταβλητή named "Δεδομένα" σε
 * πρόγραμμα ΓΛΩΣΣΑΣ. Ο Parser χρησιμοποιεί την ίδια τιμή για να επιβάλει
 * τη σωστή δομή προγράμματος (ΠΡΟΓΡΑΜΜΑ...ΤΕΛΟΣ_ΠΡΟΓΡΑΜΜΑΤΟΣ έναντι
 * ΑΛΓΟΡΙΘΜΟΣ...ΤΕΛΟΣ).
 */
export enum Dialect {
  GLOSSA = 'GLOSSA',
  PSEUDOGLOSSA = 'PSEUDOGLOSSA',
}
